import {
    FETCH_BIN_REQUEST,
    FETCH_BIN_SUCCESS,
    FETCH_BIN_ERROR,
    HIDE_BIN_LOADER,
    SHOW_BIN_LOADER,
    UPLOAD_BIN_FILE_REQUEST,
    UPLOAD_BIN_FILE_SUCCESS,
    UPLOAD_BIN_FILE_ERROR,
    UPLOAD_NETWORK_BIN_FILE_REQUEST,
    UPLOAD_NETWORK_BIN_FILE_SUCCESS,
    UPLOAD_NETWORK_BIN_FILE_ERROR,
    SEARCH_BIN_DETAIL_REQUEST,
    SEARCH_BIN_DETAIL_SUCCESS,
    SEARCH_BIN_DETAIL_ERROR,
    UPDATE_BIN_DETAIL_REQUEST,
    UPDATE_BIN_DETAIL_SUCCESS,
    UPDATE_BIN_DETAIL_ERROR,
    DOWNLOAD_BY_ID_REQUEST,
    DOWNLOAD_BY_ID_SUCCESS,
    DOWNLOAD_BY_ID_ERROR,
    GET_SEARCH_RECENT_BIN_REQUEST,
    GET_SEARCH_RECENT_BIN_SUCCESS,
    GET_SEARCH_RECENT_BIN_ERROR,
} from './manageBin.constants';

export const fetchBinDataRequest = payload => ({
    type: FETCH_BIN_REQUEST,
    payload,
});

export const fetchBinDataSuccess = payload => ({
    type: FETCH_BIN_SUCCESS,
    payload,
});

export const fetchBinDataError = payload => ({
    type: FETCH_BIN_ERROR,
    payload,
});

export const uploadBinFileRequest = payload => ({
    type: UPLOAD_BIN_FILE_REQUEST,
    payload,
});

export const uploadBinFileSuccess = payload => ({
    type: UPLOAD_BIN_FILE_SUCCESS,
    payload,
});

export const uploadBinFileError = payload => ({
    type: UPLOAD_BIN_FILE_ERROR,
    payload,
});

export const searchBinDetailRequest = payload => ({
    type: SEARCH_BIN_DETAIL_REQUEST,
    payload,
});

export const searchBinDetailSuccess = payload => ({
    type: SEARCH_BIN_DETAIL_SUCCESS,
    payload,
});

export const searchBinDetailError = payload => ({
    type: SEARCH_BIN_DETAIL_ERROR,
    payload,
});

export const updateBinDetailRequest = payload => ({
    type: UPDATE_BIN_DETAIL_REQUEST,
    payload,
});

export const updateBinDetailSuccess = payload => ({
    type: UPDATE_BIN_DETAIL_SUCCESS,
    payload,
});

export const updateBinDetailError = payload => ({
    type: UPDATE_BIN_DETAIL_ERROR,
    payload,
});

export const downloadByIdRequest = payload => ({
    type: DOWNLOAD_BY_ID_REQUEST,
    payload,
});

export const downloadByIdSuccess = payload => ({
    type: DOWNLOAD_BY_ID_SUCCESS,
    payload,
});

export const downloadByIdError = payload => ({
    type: DOWNLOAD_BY_ID_ERROR,
    payload,
});

export const getSearchRecentRequest = () => ({
    type: GET_SEARCH_RECENT_BIN_REQUEST,
});

export const getSearchRecentSuccess = payload => ({
    type: GET_SEARCH_RECENT_BIN_SUCCESS,
    payload,
});

export const getSearchRecentError = payload => ({
    type: GET_SEARCH_RECENT_BIN_ERROR,
    payload,
});

export const uploadNetworkBinFileRequest = payload => ({
    type: UPLOAD_NETWORK_BIN_FILE_REQUEST,
    payload,
});

export const uploadNetworkBinFileSuccess = payload => ({
    type: UPLOAD_NETWORK_BIN_FILE_SUCCESS,
    payload,
});

export const uploadNetworkBinFileError = payload => ({
    type: UPLOAD_NETWORK_BIN_FILE_ERROR,
    payload,
});

export const showLoader = () => ({ type: SHOW_BIN_LOADER });

export const hideLoader = () => ({ type: HIDE_BIN_LOADER });
